import { DialogProps } from '@material-ui/core'

/**
 * MUI Dialogs have a weirdly typed onClose event which requires some boilerplate
 * to get typechecking correctly. This function takes in the `props.onClose`
 * function passed along as dialog props, and wraps into something that's easily
 * used as an onClick handler
 */
export function wrapDialogOnClose(onClose?: DialogProps['onClose']) {
  return function handleClose(
    event: React.MouseEvent<HTMLButtonElement>,
  ): void {
    if (typeof onClose === 'function') {
      onClose(event, 'escapeKeyDown')
    }
  }
}
